/* global indexUrl */

import React, { Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import PurchaseOrderCustomPriceTable from '../PurchaseOrderCustomPriceTable';

import { formatDateWithTz } from 'Helpers/dateUtils';
import { formatFigure, formatMoney } from 'Helpers/formatService';

const figure = (value) => formatFigure(value, formatMoney, { precision: 3 });

export default function ProcurementHistoryReportingIndex(props) {
    const [expandedData, setExpandedData] = useState({ po: {} });
    const [purchaseOrders, setPurchaseOrders] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        axios
            .get(props.dataUrl)
            .then(({ data }) => {
                setPurchaseOrders(data.purchase_orders);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const toogglePo = (poId) => {
        const data = JSON.parse(JSON.stringify(expandedData));

        data.po[poId] = { expanded: !data.po[poId]?.expanded };

        setExpandedData(data);
    };

    return (
        <div id={'procurement-reporting-table'} className={'inbud-table_wrapper'}>
            <table className={'inbud-table'}>
                <thead>
                    <tr className={'text-blue bg-white'}>
                        <th className="tw-w-20">{$t('Expenditure Approval Number')}</th>
                        <th className="tw-w-20">{$t('Expenditure Approval Date')}</th>
                        <th className="tw-w-24">{$t('Supplier')}</th>
                        <th className="tw-w-20">{$t('Contract Number')}</th>
                        <th className="tw-w-24">{$t('Budget Line')}</th>
                        <th className="tw-w-20">{$t('Original Price')}</th>
                        <th className="tw-w-20">{$t('Original Quantity 1')}</th>
                        <th className="tw-w-20">{$t('Original Quantity 2')}</th>
                        <th className="tw-w-20">{$t('Original Quantity 3')}</th>
                        <th className="tw-w-24">{$t('Original Total')}</th>
                        <th className="tw-w-20">{$t('Revised Price')}</th>
                        <th className="tw-w-20">{$t('Revised Quantity 1')}</th>
                        <th className="tw-w-20">{$t('Revised Quantity 2')}</th>
                        <th className="tw-w-20">{$t('Revised Quantity 3')}</th>
                        <th className="tw-w-20">{$t('Revised Total')}</th>
                        <th className="tw-w-24">{$t('Variance')}</th>
                    </tr>
                </thead>
                <tbody>
                    {purchaseOrders.map((po) => {
                        const displayOrder = !!expandedData.po[po.id]?.expanded;
                        return <PoRow key={`po-${po.id}`} po={po} toogglePo={() => toogglePo(po.id)} displayOrder={displayOrder} />;
                    })}
                </tbody>
            </table>
        </div>
    );
}

if (document.getElementById('procurementHistoryReporting')) {
    const root = document.getElementById('procurementHistoryReporting');
    ReactDOM.render(
        <App>
            <ProcurementHistoryReportingIndex dataUrl={indexUrl} />
        </App>,
        root,
    );
}

const PoRow = (props) => {
    const [displayDetails, setDisplayDetails] = useState([]);
    useEffect(() => {
        const res = [];
        props.po.detailed_amount.map((row, index) => {
            res.push(false);
        });
        setDisplayDetails(res);
    }, []);

    const toggleDisplay = (index, hasCustomPrices) => {
        if (hasCustomPrices) {
            const data = JSON.parse(JSON.stringify(displayDetails));
            data[index] = !data[index];
            setDisplayDetails(data);
        }
    };

    return (
        <Fragment>
            <tr className="cursor-pointer" onClick={() => props.toogglePo()}>
                <td>
                    {props.po.code}
                    <br />
                    <span className="ml-1 mr-2">{props.displayOrder ? <i className={'fa fa-chevron-up'} /> : <i className={'fa fa-chevron-down'} />}</span>
                </td>
                <td className="inbud-date-cell">{formatDateWithTz(props.po.submission_date, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY')}</td>
                <td>{props.po.supplier ? props.po.supplier.name : '-'}</td>
                <td>{props.po.supplier_contract ? props.po.supplier_contract.contract_reference : '-'}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="inbud-numeric-cell">{figure(props.po.final_price)}</td>
                <td className="inbud-numeric-cell">{figure(props.po.variance)}</td>
            </tr>
            {props.displayOrder &&
                props.po.detailed_amount.map((row, index) => {
                    const hasCustomPrices =
                        (row.original_custom_prices && row.original_custom_prices.length > 0) ||
                        (row.revised_custom_prices && row.revised_custom_prices.length > 0);

                    const show = displayDetails[index] || false;

                    if (!!row.type && row.type === 'project') {
                        return null;
                    }

                    return (
                        <Fragment key={`po-${props.po.id}-row-${index}`}>
                            <tr className={`${hasCustomPrices ? 'cursor-pointer' : ''}`} onClick={() => toggleDisplay(index, hasCustomPrices)}>
                                <td>
                                    {hasCustomPrices && (
                                        <span className="ml-1 mr-2">
                                            {show ? <i className={'fa fa-chevron-up'} /> : <i className={'fa fa-chevron-down'} />}
                                        </span>
                                    )}
                                    {props.po.code}
                                </td>
                                <td className="inbud-date-cell">{formatDateWithTz(props.po.submission_date, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY')}</td>
                                <td>{props.po.supplier ? props.po.supplier.name : '-'}</td>
                                <td>{props.po.supplier_contract ? props.po.supplier_contract.contract_reference : '-'}</td>
                                <td>{row.budget_line}</td>
                                <td className="inbud-numeric-cell">{figure(row.original_price)}</td>
                                <td className="inbud-numeric-cell">{formatFigure(row.original_quantity[0]?.amount, (x) => x, { precision: 4 })}</td>
                                <td className="inbud-numeric-cell">{formatFigure(row.original_quantity[1]?.amount, (x) => x, { precision: 4 })}</td>
                                <td className="inbud-numeric-cell">{formatFigure(row.original_quantity[2]?.amount, (x) => x, { precision: 4 })}</td>
                                <td className="inbud-numeric-cell">{figure(row.original_total)}</td>
                                <td className="inbud-numeric-cell">{figure(row.revised_price)}</td>
                                <td className="inbud-numeric-cell">{formatFigure(row.revised_quantity[0]?.amount, (x) => x, { precision: 4 })}</td>
                                <td className="inbud-numeric-cell">{formatFigure(row.revised_quantity[1]?.amount, (x) => x, { precision: 4 })}</td>
                                <td className="inbud-numeric-cell">{formatFigure(row.revised_quantity[2]?.amount, (x) => x, { precision: 4 })}</td>
                                <td className="inbud-numeric-cell">{figure(row.revised_total)}</td>
                                <td className="inbud-numeric-cell">{figure(row.variance)}</td>
                            </tr>
                            {hasCustomPrices && show && (
                                <>
                                    <tr>
                                        <td colSpan={16} className="tw-px-4 tw-py-5 !tw-bg-blue-25/50">
                                            <PurchaseOrderCustomPriceTable row={row} index={index} prefix={`po-${props.po.id}`} />
                                        </td>
                                    </tr>
                                </>
                            )}
                        </Fragment>
                    );
                })}
        </Fragment>
    );
};
